import CompletedTodo from "./components/CompletedTodo";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import TodoList from "./components/TodoList";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "./redux/todos/thunk/fetchTodos";

function App() {
    const todos = useSelector((state) => state.todos);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTodos);
    }, [dispatch]);

    return (
        <div className="grid place-items-center bg-blue-100 h-screen px-6 font-sans">
            <Navbar />

            <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
                <Header />
                <hr className="mt-4" />
                <TodoList />
                <hr className="mt-4" />
                <Footer />
                <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
                    <h2 className="bg-green-100 h-10 px-3 rounded flex items-center mt-4 mb-2 text-green-600">
                        Completed Todos : (
                        {
                            todos.filter((item) => item.completed !== false)
                                .length
                        }
                        )
                    </h2>
                    {todos?.map(
                        (todo) =>
                            todo.completed !== false && (
                                <CompletedTodo todo={todo} key={todo.id} />
                            )
                    )}
                </div>
            </div>
        </div>
    );
}

export default App;
